import { CloseOutlined, EditTwoTone, SaveOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Row, Select } from "antd";
import React, { useEffect } from "react";
import PracticesService, { IPracticeAddress, IPracticeBasicInformationInitialValues, PracticeUpdateTypes } from "../../Services/PracticesService";
import { Utils } from "../../Utilities/Utils";
import { adminContext } from "../../Common/PageRoute";
import BankAccount from "./BankAccount";
import { useUser } from "../../Context/UserContext";

const BasicInformation = ({
  isEdit,
  setIsEdit,
  setLoading,
  practiceId,
  refreshTrigger,
}: {
  isEdit: { type: PracticeUpdateTypes };
  setIsEdit: React.Dispatch<React.SetStateAction<{ type: PracticeUpdateTypes }>>;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  practiceId: number;
  refreshTrigger: number;
}) => {
  const { countriesOptions } = React.useContext(adminContext);
  const { openNotification } = React.useContext(adminContext);
  const { isSubAdmin } = useUser();
  const isViewOnly = isSubAdmin();
  const [form] = Form.useForm();
  const [initialValues, setInitialValues] = React.useState<any>(null);

  const getBasicInformation = async () => {
    try {
      setLoading(true);
      const res = await PracticesService.getPracticeBasicInformation(practiceId);
      if (res?.status) {
        const fieldValues = {
          name: res?.result?.name,
          email: res?.result?.email,
          phoneNumber: res?.result?.phoneNumber,
          website: res?.result?.website,
          address: res?.result?.address,
          bankAccount: res?.result?.bankAccount,
        };
        form.setFieldsValue(fieldValues);
        setInitialValues(fieldValues);
      } else {
        openNotification("error", res?.message || "Error fetching basic information");
      }
    }
    catch (error) {
      openNotification("error", "Error fetching basic information");
    }
    finally {
      setLoading(false);
    }
  }
useEffect(() => {
  getBasicInformation();
}, [refreshTrigger]);

  const handleCancel = () => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
    }
    setIsEdit({ type: PracticeUpdateTypes.unknown });
  };

  const saveBasicInformation = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();

      let request: Promise<any> | null = null;

      if (isEdit.type === PracticeUpdateTypes.basicInformation) {
        const params: IPracticeBasicInformationInitialValues = {
          name: values.name,
          email: values.email,
          phoneNumber: values.phoneNumber,
          website: values.website,
        };
        request = PracticesService.updatePracticeBasicInformation(practiceId, params);
      }

      if (isEdit.type === PracticeUpdateTypes.address) {
        const params: IPracticeAddress = values.address;
        request = PracticesService.updatePracticeAddressInformation(practiceId, params);
      }

      if (!request) return;

      const res = await request;

      if (res?.result) {
        openNotification("success", "Information updated successfully");
        setIsEdit({ type: PracticeUpdateTypes.unknown });
        setInitialValues(values);
      } else {
        openNotification("error", res?.message || "Error updating basic information");
      }
    } catch {
      openNotification("error", "Error updating basic information");
    } finally {
      setLoading(false);
    }
  };




  return (
    <Form form={form}
      // onValuesChange={handleValuesChange}
      disabled={isViewOnly}
    >
      <Col className="card border pb-3 border-rounded-1 bg-secondary">
        <Row
          className="border-bottom  px-2 py-1 font-bold"
          justify="space-between"
        >
          Basic information
          {!isViewOnly &&
            <Button
              icon={<EditTwoTone />}
              type="text"
              // disabled={isInactive}
              style={{ border: "none" }}
              onClick={() =>
                setIsEdit({ type: PracticeUpdateTypes.basicInformation })
              }
            />
          }
        </Row>
        <Row className="px-3 pt-1">
          <Col span={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
              label="Name"
              name="name"
              rules={[
                { required: true, message: "Name is requried" },
                { validator: Utils.validateWhiteSpace },
              ]}
            >
              <Input
                disabled={
                  isEdit.type === PracticeUpdateTypes.basicInformation
                    ? false
                    : true
                }
                onInput={(e: any) =>
                (e.target.value =
                  e.target.value.length > 1
                    ? e.target.value
                    : e.target.value.toUpperCase())
                }
                className="line-height-28"
                placeholder="Name"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 18 }}
              label="Email"
              name="email"
              rules={[
                { required: true, message: "Email is required" },
                { validator: Utils.ValidateEmailFormat },
              ]}
            >
              <Input
                disabled={
                  isEdit.type === PracticeUpdateTypes.basicInformation
                    ? false
                    : true
                }
                className="line-height-28"
                placeholder="Email"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 8 }}
              label="Phone number"
              name="phoneNumber"
              rules={[
                { required: true, message: "Phone number is required" },
              ]}
            >
              <Input
                disabled={
                  isEdit.type === PracticeUpdateTypes.basicInformation
                    ? false
                    : true
                }
                onKeyPress={(e) => Utils.ValidateNumberOnly(e)}
                maxLength={13}
                className="line-height-28"
                placeholder="Phone Number"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row className="px-3">
          <Col span={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
              label="URL"
              name={["website", "url"]}
            >
              <Input
                disabled={
                  isEdit.type === PracticeUpdateTypes.basicInformation
                    ? false
                    : true
                }
                className="line-height-28"
                placeholder="URL"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 18 }}
              label="URL T&C"
              name={["website", "urlTnC"]}
            >
              <Input
                disabled={
                  isEdit.type === PracticeUpdateTypes.basicInformation
                    ? false
                    : true
                }
                className="line-height-28"
                placeholder="URL T&C"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 18 }}
              label="URL privacy"
              name={["website", "urlPrivacy"]}
            >
              <Input
                disabled={
                  isEdit.type === PracticeUpdateTypes.basicInformation
                    ? false
                    : true
                }
                className="line-height-28"
                placeholder="URL privacy"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row className="px-3">
          <Col span={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
              label="Icon URL"
              name={["website", "iconUrl"]}
            >
              <Input
                disabled={
                  isEdit.type === PracticeUpdateTypes.basicInformation
                    ? false
                    : true
                }
                className="line-height-28"
                placeholder="Icon URL"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 18 }}
              label="Logo URL"
              name={["website", "logoUrl"]}
            >
              <Input
                disabled={
                  isEdit.type === PracticeUpdateTypes.basicInformation
                    ? false
                    : true
                }
                className="line-height-28"
                placeholder="Logo URL"
              />
            </Form.Item>
          </Col>
        </Row>
        {!isViewOnly && isEdit.type === PracticeUpdateTypes.basicInformation && (
          <Row className="px-3 pt-3">
            <Button type="primary"
              onClick={saveBasicInformation}
            >
              <SaveOutlined /> Save
            </Button>
            <Button className="ms-2" onClick={handleCancel}>
              <CloseOutlined /> Cancel
            </Button>
          </Row>
        )}
      </Col>
      <Col className="card border pb-3 border-rounded-1 bg-secondary my-4">
        <Row
          className="border-bottom  px-2 py-1 font-bold"
          justify="space-between"
        >
          Address Details
          {!isViewOnly &&
            <Button
              icon={<EditTwoTone />}
              type="text"
              // disabled={isInactive}
              style={{ border: "none" }}
              onClick={() => setIsEdit({ type: PracticeUpdateTypes.address })}
            />
          }
        </Row>
        <Row className="px-3 pt-1">
          <Col span={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
              label="Building"
              name={["address", "building"]}
            >
              <Input
                disabled={
                  isEdit.type === PracticeUpdateTypes.address ? false : true
                }
                className="line-height-28"
                placeholder="Building"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
              label="Street"
              name={["address", "street"]}
            >
              <Input
                disabled={
                  isEdit.type === PracticeUpdateTypes.address ? false : true
                }
                className="line-height-28"
                placeholder="Street"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
              label="City/Town"
              name={["address", "city"]}
            >
              <Input
                disabled={
                  isEdit.type === PracticeUpdateTypes.address ? false : true
                }
                className="line-height-28"
                placeholder="City/Town"
              />
            </Form.Item>
          </Col>
        </Row>
        <Row className="px-3 ">
          <Col span={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
              label="County"
              name={["address", "county"]}
            >
              <Input
                disabled={
                  isEdit.type === PracticeUpdateTypes.address ? false : true
                }
                onKeyPress={(e: any) => Utils.ValidateCharOnly(e)}
                className="line-height-28"
                placeholder="County"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
              label="Post code"
              name={["address", "postcode"]}
            >
              <Input
                disabled={
                  isEdit.type === PracticeUpdateTypes.address ? false : true
                }
                onKeyPress={(e: any) => Utils.ValidateCharAndNumberOnly(e)}
                className="line-height-28"
                placeholder="Post code"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              className="custom-form-item"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 12 }}
              label="Country"
              name={["address", "country"]}
            >
              <Select
                showSearch
                disabled={
                  isEdit.type === PracticeUpdateTypes.address ? false : true
                }
                className="line-height-28"
                placeholder="Country"
                options={countriesOptions}
              />
            </Form.Item>
          </Col>
        </Row>
        {!isViewOnly && isEdit.type === PracticeUpdateTypes.address && (
          <Row className="px-3 pt-3">
            <Button type="primary" onClick={saveBasicInformation}>
              <SaveOutlined /> Save
            </Button>
            <Button className="ms-2" onClick={handleCancel}>
              <CloseOutlined /> Cancel
            </Button>
          </Row>
        )}
      </Col>

      <BankAccount
        form={form}
        isEdit={isEdit}
        setIsEdit={setIsEdit}
      // OnSaveClick={OnSaveClick}
      // OnCancelClick={OnCancelClick}
      // handleValuesChange={handleValuesChange}
      // isInactive={inactive}
      />
    </Form>
  );
};
//jb primary change krte hai from one bank to another bank then update hoti h practice abnk and jo primary bank accounts h wo practice ke bank information m update hoti h bt problem ye h ky jb update krti hun tb without refresh ye practice ke basic information m show nhi hoti h

export default BasicInformation;
